<template>
    <th v-if="type === 'text'" scope="row" :class="cls[type]" :style="{...colorStyle, fontSize: fontSize, fontWeight: fontWeight}">{{ value }}</th>
    <td v-else :class="cls[type]" :style="{...colorStyle, fontSize: fontSize, fontWeight: fontWeight}">{{ value }}</td>
</template>

<script>

export default {
    name: 'SummaryPanelBodyItem',
    props: {
        type: String,
        value: String,
        checkValue: Boolean,
        fontSize: {
            type: String,
            default: '0.9rem'
        },
        fontWeight: {
            type: String,
            default: 'bold'
        },
        color: {
            type: String,
            default: ''
        },
        isOpposite: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            cls: {
                text: 'text',
                value: 'value'
            }
        }
    },
    computed: {
        colorStyle() {
            if (this.checkValue) {
                const val = this.value ? this.value.replace('%', '') : 0;
                let color = 'var(--instagram-title-color)';
                if (this.isOpposite) {
                    if (val > 0) {
                        color = '#f21d1d';
                    } else if (val < 0) {
                        color = '#00bb3f';
                    }
                } else {
                    if (val > 0) {
                    color = '#00bb3f';
                    } else if (val < 0) {
                        color = '#f21d1d';
                    }
                }

                return {
                    color: color
                }
            } else {
                return {
                    color: this.color
                }
            }
        }
    }
}
</script>